import { useEffect } from "react";

export default function SellEquity(props) {
  useEffect(() => {
    window.location.href = "/buy_equity#redeem";
  }, []);
  return <div className="Page page-layout"></div>;
}
